import { Col, type ColProps } from 'antd';
import { type JSX, type ReactNode } from 'react';

type ColumnOrFragmentProps = Omit<ColProps, 'children'> & {
    children: ReactNode;
    asFragment?: boolean;
};

const ColumnOrFragment = ({ children, asFragment, ...columnProps }: ColumnOrFragmentProps): JSX.Element => {
    if (asFragment) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <>{children}</>;
    }

    return <Col {...columnProps}>{children}</Col>;
};

export default ColumnOrFragment;
